import { useEffect, useState } from "react";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import "./studentLesson.css";
import { useDispatch, useSelector } from "react-redux";
import { updateLessonTableAction } from "../../../redux/actions/lessonTableActions";
import { LESSON_TABLE_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { Checkbox, TextField } from "@mui/material";
import LoadingBtn from "../../../globalComponents/Loading/components/LoadingBtn/LoadingBtn";

const StudentLessonModal = ({ targetLesson, setTargetLesson }) => {
  const { status, type } = useSelector((state) => state.lessonTablePagination);
  const { startDate, endDate } = useSelector((state) => state.datepicker);
  const { lessonTableSearchValues } = useSelector(
    (state) => state.searchValues
  );
  const { selectedTeacher } = useSelector((state) => state.dropdownTeacher);
  const { selectedGroup, groupStatus } = useSelector(
    (state) => state.dropdownGroup
  );

  const activeStudents = targetLesson?.students?.filter((item) => {
    const targetGroupItem = item?.student?.groups?.find(
      (groupItem) => groupItem.group === targetLesson.group._id
    );

    return (
      item.attendance !== 0 ||
      ["waiting", "graduate", "continue", "debtor-graduate"].includes(
        targetGroupItem?.status
      )
    );
  });

  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [togggleIcon, setToggleIcon] = useState("");
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isActiveEduElements, setIsActiveEduElements] = useState(false);
  const [isDisabledUpdateBtn, setIsDisabledUpdateBtn] = useState(true);

  const updateLessonStudents = () => {
    if (isDisabledUpdateBtn) return;

    dispatch(
      updateLessonTableAction(
        targetLesson._id,
        {
          ...targetLesson,
          students: targetLesson.students,
          isEduConfirmedAttendance: targetLesson.isEduConfirmedAttendance,
          attendingStudentsCount: targetLesson.attendingStudentsCount,
        },
        lessonTableSearchValues,
        selectedGroup?._id || "",
        selectedTeacher._id,
        startDate,
        endDate,
        status,
        groupStatus,
        type === "all" ? "" : type
      )
    );
  };

  const getBackgroundColor = (item) => {
    if (item.attendance === 1) {
      return "#D4FFBF";
    } else if (item.attendance === -1) {
      return "#FFCED1";
    } else {
      return "";
    }
  };

  const handleStatusChange = (newItem) => {
    const newStudentsList = targetLesson.students.map((item) =>
      item._id === newItem._id ? newItem : item
    );
    setTargetLesson((prev) => ({ ...prev, students: newStudentsList }));
  };

  useEffect(() => {
    if (user?.role === "super-admin") {
      setIsActiveEduElements(true);
      setIsDisabledUpdateBtn(false);
    }

    if (user?.role === "worker") {
      const power = user?.profiles?.find(
        (item) => item.profile === "lessonTable"
      )?.power;

      if (power === "all" || power === "update") {
        setIsActiveEduElements(true);
        setIsDisabledUpdateBtn(false);
      }
    }

    if (
      user?.role === "mentor" &&
      user?._id === targetLesson?.mentor?._id &&
      targetLesson?.topic?.name === "Praktika"
    ) {
      const checkAttendance = activeStudents?.find(
        (item) => item.attendance === 0
      );
      if (checkAttendance) {
        setIsDisabledUpdateBtn(true);
      } else {
        setIsDisabledUpdateBtn(false);
      }
    }

    if (
      user?.role === "teacher" &&
      user?._id === targetLesson?.teacher?._id &&
      targetLesson?.topic?.name !== "Praktika"
    ) {
      const checkAttendance = activeStudents?.find(
        (item) => item.attendance === 0
      );

      if (checkAttendance) {
        setIsDisabledUpdateBtn(true);
      } else {
        setIsDisabledUpdateBtn(false);
      }
    }
  }, [user, targetLesson]);

  // console.log(isDisabledUpdateBtn, "Is Disabled Update Btn");
  return (
    <div className="create-update-modal-con">
      <div className="student-lesson-modal">
        <div className="create-update-modal-head">
          <p className="content-type">Tələbələr</p>
          <CloseBtn
            onClick={() =>
              dispatch({
                type: LESSON_TABLE_MODAL_ACTION_TYPE.STUDENT_MODAL,
                payload: false,
              })
            }
          />
        </div>
        <div className="students-list">
          {activeStudents?.map((item) => (
            <div
              style={{ backgroundColor: getBackgroundColor(item) }}
              onClick={() =>
                setToggleIcon(
                  togggleIcon === item.student._id ? "" : item.student._id
                )
              }
              className={`student-list ${
                selectedStudentId === item.student._id ? "selected" : ""
              }`}
              key={item.student._id}
            >
              <div className="student-name">{item.student.fullName}</div>

              <div
                onClick={() => {
                  setSelectedStudentId(
                    selectedStudentId === item.student._id
                      ? ""
                      : item.student._id
                  );
                }}
                className="drop-icon"
              >
                <div className="dropdown-icon">
                  <svg
                    className={togggleIcon === item.student._id ? "up" : "down"}
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9465 5.95337L7.79316 5.95337L4.05317 5.95337C3.41317 5.95337 3.09317 6.7267 3.5465 7.18004L6.99983 10.6334C7.55317 11.1867 8.45317 11.1867 9.0065 10.6334L10.3198 9.32003L12.4598 7.18003C12.9065 6.7267 12.5865 5.95337 11.9465 5.95337Z"
                      fill="#717171"
                    />
                  </svg>
                </div>
              </div>
              {togggleIcon === item.student._id && (
                <div
                  className={`status ${
                    togggleIcon === item.student._id ? "active" : ""
                  }`}
                >
                  <p
                    onClick={() =>
                      handleStatusChange({ ...item, attendance: 1 })
                    }
                  >
                    i/e
                  </p>
                  <p
                    onClick={() =>
                      handleStatusChange({ ...item, attendance: -1 })
                    }
                  >
                    q/b
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginTop: "30px",
          }}
        >
          {(isActiveEduElements && (
            <>
              <TextField
                id="outlined-basic"
                variant="outlined"
                label="Koord. i/e sayı"
                type="number"
                value={targetLesson.attendingStudentsCount || ""}
                sx={{
                  width: "150px",
                  "& .MuiInputBase-input": {
                    padding: "11px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: "14px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "10px",
                  },
                }}
                onChange={(e) =>
                  setTargetLesson((prev) => ({
                    ...prev,
                    attendingStudentsCount: e.target.value,
                  }))
                }
              />
            </>
          )) || <div></div>}

          <div className="create-update-modal-btn">
            <button
              disabled={isDisabledUpdateBtn}
              onClick={updateLessonStudents}
              style={isDisabledUpdateBtn ? { cursor: "not-allowed" } : {}}
            >
              {false ? <LoadingBtn /> : "Təsdiqlə"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentLessonModal;
